import {useEffect} from 'react'
import {Navigate, Routes, Route} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {getJwtToken, getUserByToken} from './core/_requests'

interface SingleSignOnProps {
  sso: string
}

export const SingleSignOn: React.FC<SingleSignOnProps> = ({sso}: SingleSignOnProps) => {
  const {setCurrentUser, saveAuth, currentUser, logout} = useAuth()

  useEffect(() => {
    const _getJWTToken = async () => {
      if (sso !== null) {
        try {
          // Arriving via SSO supersedes any stored session — drop it so the
          // request interceptor can't attach a stale token to the exchange.
          saveAuth(undefined)
          const {data: auth} = await getJwtToken(sso)
          if (auth !== null && auth.access_token !== null) {
            saveAuth(auth)
            const {data: user} = await getUserByToken(auth.access_token)
            setCurrentUser(user)
            window.location.replace('/labor-scheduling/scheduling/overview')
            return
          }
        } catch (error) {
          // Exchange failed (the sso token lives 20s — e.g. a stale tab
          // reload): fall through to the backend login below.
          console.error(error)
        }
      }
      window.location.replace(process.env.REACT_APP_OLD_FLASK_APP_URL || '/auth/login')
    }
    _getJWTToken()
  }, [])

  return <div>Loading...</div>
}
